import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Select } from 'antd';
import { LabelText, SubmitButton, FlexContainer, LeftBackButtonText, H1Text, Hr, Text, SelectBox } from "../../design";
import { BASE_URLS, getListConnect, axiosAuthInstance, API } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import SuccessModal from "../../components/modal/success";

const { Option } = Select;

type Props = {
    history: {
        push: Function,
    },
}

const LinkPartner = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const publicKey = localStorage.getItem('publicKey');
    const [selectedGid, setSelectedGid] = useState(null);
    const [options, setOptions] = useState([]);
    const [affilateData, setAffilateData] = useState('');
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const processStatus = false;


    const { handleSubmit } = useForm();

    useEffect(() => {
        getAllConnectList();
        getData();
    }, []);

    const getData = async () => {
        try {
            const { data: { entity: userEntity } } = await axiosAuthInstance.get(BASE_URLS.USER_PROFILE);
            const params = {
                email: userEntity.user.email,
                name: userEntity.user.fullName,
                notificationType: "NONE",
                phoneNumber: userEntity.user.phoneNumber,
                type: "EMAIL",
            };
            const config = {
                headers: {
                    'x-api-key': publicKey,
                }
            };
            if (userEntity && userEntity.user) {
                const { data: { entity } } = await API.post(BASE_URLS.AFFILIATE_ACCOUNT, params, config);
                setAffilateData(entity);
                localStorage.removeItem('email');
            }

        } catch (e) {
            setShowErrorMessage(true);
            setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
        }
    };

    const getAllConnectList = async () => {
        try {
            const value = await getListConnect();
            if (value?.content) {
                setOptions(value?.content);
            }
        } catch (reason) {
            console.log(reason);
        }
    };

    const onSubmit = async () => {
        if (!selectedGid) {
            setShowErrorMessage(true);
            setErrorMessage('Please select the account to link')
            return
        }
        try {
            const { data: { entity } } = await axiosAuthInstance.post(`${BASE_URLS.PARTNER_CONNECT}/${selectedGid}/${affilateData?.affiliateCode}/link`, {});
            setTransactionSuccessModalOpen(true);
            if (entity?.redirectUri) {
                window.location = entity?.redirectUrl;
            }
            setTimeout(() => {
                setTransactionSuccessModalOpen(false);
                const encodedKey = btoa(publicKey)
                const redirectUri = `/connect?key=${encodedKey}&mode=AUTH`
                props.history.replace(redirectUri);
            }, 10000);
        } catch (e) {
            setShowErrorMessage(true);
            setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
        } finally {
            localStorage.removeItem('authMode');
        }
    }

    const handleChange = (e) => {
        setSelectedGid(e?.target?.value);
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(`/connect/create?key=${btoa(publicKey)}`); }}
                        >
                            Back
                        </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        CHOOSE AN ACCOUNT
                    </H1Text>

                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        We found multiple accounts associated with your email address. Please select the account you'd like to link.
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <LabelText className="mt-4 mb-3">
                                    Account Name
                                </LabelText>
                                <SelectBox
                                    className="mb-3"
                                    value={selectedGid}
                                    style={{ color: '#6A6A6A', width: '300px' }}
                                    onChange={handleChange}
                                >
                                    {!selectedGid && <option></option>}
                                    {
                                        options
                                            .map((item) => (
                                                <option key={item.gid} value={item?.gid}>
                                                    {item.name}
                                                </option>
                                            ))
                                    }
                                </SelectBox>
                                <div>
                                    <SubmitButton
                                        type="submit"
                                        marginTop="4px"
                                        style={{ width: '292px' }}
                                    >Select </SubmitButton>
                                </div>
                                {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                            </form>
                        </FlexContainer>
                    </div>
                </FlexContainer>
                <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} accountId={null} paymentId={null} message={'Your  account is successfully linked to the partner account'} pauseType={null} />
            </>
        } />
    )
};

export default LinkPartner;
